<template>
    <div class="table">
        <div class="container">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList('search')">
                <el-form-item label="登录名">
                    <el-input v-model="dataForm.username" onkeypress="if(event.keyCode == 13) return false;"
                              placeholder="请输入登录名" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList('search')" icon="el-icon-search">查询</el-button>
                    <el-button type="primary" v-if="isAuth('sys-user-add')"
                               @click="addOrUpdateSysUser()">新增
                    </el-button>
                    <el-button type="danger" @click="deleteHandle()"
                               v-if="isAuth('sys-user-delete')"
                               :disabled="dataListSelections.length <= 0">批量删除
                    </el-button>
                </el-form-item>
            </el-form>
            <el-table
                    :data="dataList"
                    border
                    v-loading="dataListLoading"
                    @selection-change="selectionChangeHandle"
                    style="width: 100%;">
                <el-table-column
                        type="selection"
                        header-align="center"
                        align="center"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="id"
                        header-align="center"
                        align="center"
                        width="80"
                        label="编号">
                </el-table-column>
                <el-table-column
                        prop="username"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="登录名">
                </el-table-column>
                <el-table-column
                        prop="nameZh"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="角色">
                </el-table-column>
                <el-table-column
                        prop="loginAddress"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="最后登录地点">
                </el-table-column>
                <el-table-column
                        prop="lastLoginDate"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="最后登录时间">
                </el-table-column>
                <el-table-column
                        prop="count"
                        header-align="center"
                        align="center"
                        label="登录次数">
                </el-table-column>
                <el-table-column
                        prop="enabled"
                        header-align="center"
                        align="center"
                        width="100"
                        label="状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.enabled === true" type="success">正常</el-tag>
                        <el-tag v-if="scope.row.enabled === false" type="danger">禁用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        header-align="center"
                        align="center"
                        width="150"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini"
                                   @click="addOrUpdateSysUser(scope.row.id)"
                                   v-if="isAuth('sys-user-edit')"
                                   :disabled="scope.row.username==='admin'">编辑
                        </el-button>
                        <el-button type="danger" size="mini"
                                   :disabled="scope.row.username==='admin'"
                                   v-if="isAuth('sys-user-delete')"
                                   @click="deleteHandle(scope.row.id)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    @size-change="sizeChangeHandle"
                    @current-change="currentChangeHandle"
                    :current-page="pageIndex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    :total="totalPage"
                    layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <sys-user-add-or-update v-if="addOrUpdateVisible" ref="sysUser"
                                @getDataList="getDataList()"></sys-user-add-or-update>
    </div>
</template>

<script>
    import {SysUser} from "../../api/sysUser";
    import sysUserAddOrUpdate from './sys-user-add-or-update';

    export default {
        name: "sys-user",
        data() {
            return {
                dataForm: {
                    username: ''
                },
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false,
                tipValue: false
            }
        },
        components: {
            sysUserAddOrUpdate
        },
        created() {
            this.getDataList();
        },
        activated() {
            this.getDataList();
        },
        methods: {
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val;
            },
            /**
             * 获取数据
             */
            getDataList(type) {
                this.dataListLoading = true;
                if (type === 'search') {
                    this.pageIndex = 1;
                }
                let params = {
                    'username': this.dataForm.username,
                    'pageIndex': this.pageIndex,
                    'limit': this.pageSize
                };
                SysUser.getSysUserList(params).then(res => {
                    if (res.code === 0) {
                        this.dataList = res.page.list;
                        this.totalPage = res.page.totalCount;
                    }
                    this.dataListLoading = false;
                });
            },
            /**
             * 添加或修改系统用户
             * @param id
             */
            addOrUpdateSysUser(id) {
                this.addOrUpdateVisible = true;
                this.$nextTick(() => {
                    this.$refs.sysUser.init(id)
                })
            },
            /**
             * 删除
             * @param id
             */
            deleteHandle(id) {
                let ids = id ? id.toString() : this.dataListSelections.map(item => item.id).join();
                //console.log(ids)
                let arrayIds = {'ids': ids};
                this.$confirm('此操作将永久删除系统用户, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    SysUser.deleteSysUser(arrayIds).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.$nextTick(() => {
                                        this.getDataList();
                                    })
                                }
                            })
                        }
                    });
                }).catch(() => {
                })
            }
        }
    }
</script>

<style scoped>

</style>
